import {
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  withStyles,
} from '@material-ui/core';
import * as icons from '@material-ui/icons';
import classNames from 'classnames';
import * as React from 'react';
import { connect } from 'react-redux';
import { Link, Route, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { Dispatch } from 'redux';
import TopBar from '../../components/TopBar/TopBar';
import ErrorBoundary from '../../hoc/ErrorBoundary';
import { admin as routes } from '../../routes';
import { ILoginAction, logout } from '../../store/actions/auth';
import { IAuthState } from '../../store/reducers/auth';
import menuItems from './menuItems';

import styles from './styles';

class Admin extends React.Component<any, any> {
  public state = {
    drawerOpened: false,
  };

  public handleDrawer(open: boolean) {
    return () => {
      this.setState({
        drawerOpened: open,
      });
    };
  }

  public render() {
    const { classes, auth: { user } } = this.props;
    return (
      <ErrorBoundary>
        <div className={classes.root}>
          <TopBar
            logout={this.props.logout}
            fullName={`${user.given_name} ${user.family_name}`}
            onClickMenu={this.handleDrawer(true)}
            classes={{
              root: classNames(classes.appBar, this.state.drawerOpened && classes.appBarShift),
              menuIcon: classNames(classes.menuButton, this.state.drawerOpened && classes.hide),
              title: classes.title,
            }}
            isDrawerOpened={this.state.drawerOpened}
          />
          <Drawer
            variant="permanent"
            classes={{
              paper: classNames(
                classes.drawerPaper,
                !this.state.drawerOpened && classes.drawerPaperClose
              ),
            }}
            open={this.state.drawerOpened}
          >
            <div className={classes.toolbar}>
              <IconButton onClick={this.handleDrawer(false)}>
                <icons.ChevronLeft />
              </IconButton>
            </div>

            {menuItems(user.roles.includes("sales") ? "sales" : "root").map((list, listId) => (
              <div key={listId}>
                <Divider />
                <List component="nav">
                  {list.map(item => (
                    <Tooltip
                      title={item.title}
                      placement="right"
                      disableFocusListener={this.state.drawerOpened}
                      disableHoverListener={this.state.drawerOpened}
                      disableTouchListener={this.state.drawerOpened}
                      key={item.title}
                    >
                      <ListItem button={true} component={Link} {...{ to: item.to } as any}>
                        <ListItemIcon>
                          <item.icon />
                        </ListItemIcon>
                        <ListItemText primary={item.title} />
                      </ListItem>
                    </Tooltip>
                  ))}
                </List>
              </div>
            ))}
          </Drawer>
          <main className={classes.content}>
            <div className={classes.toolbar} />
            {routes.map((route, i) => (
              <Route {...route} key={i} />
            ))}
          </main>
        </div>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = (state: { auth: IAuthState }) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<ILoginAction>) => {
  return {
    logout: () => dispatch(logout()),
  };
};

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withStyles(styles)
)(Admin);



// WEBPACK FOOTER //
// ./src/containers/Admin/Admin.tsx